import {ActionType} from "../actionTypes";
import {Action} from "../actions/flyerClassesActions";
import {ErrorDto, FlyerClassDto} from "../../dtos";

const initialState = {
    flyerClasses: [],
    loading: true,
    error: null,
    type: null,
    successInfo: null
}

interface initialStateInterface {
    flyerClasses: FlyerClassDto[] | [],
    loading: boolean,
    error: ErrorDto | null,
    type: null | string,
    successInfo: null | string;
}

export const flyerClassesReducer = (state: initialStateInterface = initialState, action: Action): initialStateInterface => {

    switch (action.type) {
        case ActionType.GET_FLYER_CLASSES_START: {
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        }
        case ActionType.GET_FLYER_CLASSES_SUCCESS: {
            return { ...state, flyerClasses: action.payload, error: null, loading: false, type: action.type };
        }
        case ActionType.GET_FLYER_CLASSES_ERROR: {
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        }
        case ActionType.GET_FLYER_CLASSES_COMPLETE: {
            return { ...state, error: null, loading: false, type: action.type };
        }
        case ActionType.DELETE_FLYER_CLASS_START: {
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        }
        case ActionType.DELETE_FLYER_CLASS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                type: action.type,
                flyerClasses: state.flyerClasses.filter((flyerClass: FlyerClassDto) => {
                    const isFlyerClassShouldBeRemoved = action.payload.some(id => id.toString() === flyerClass.id);
                    if(!isFlyerClassShouldBeRemoved){
                        return flyerClass;
                    }
                }),
            };
        }
        case ActionType.DELETE_FLYER_CLASS_ERROR: {
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        }
        case ActionType.DELETE_FLYER_CLASS_COMPLETE: {
            return { ...state, error: null, loading: false, type: action.type };
        }
        case ActionType.CREATE_FLYER_CLASS_START: {
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        }
        case ActionType.CREATE_FLYER_CLASS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                type: action.type,
                flyerClasses: [...action.payload, ...state.flyerClasses],
            };
        }
        case ActionType.CREATE_FLYER_CLASS_ERROR: {
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        }
        case ActionType.CREATE_FLYER_CLASS_COMPLETE: {
            return { ...state, error: null, loading: false, type: action.type };
        }
        case ActionType.UPDATE_FLYER_CLASS_START: {
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        }
        case ActionType.UPDATE_FLYER_CLASS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                type: action.type,
                flyerClasses: state.flyerClasses.map((flyerClass: FlyerClassDto) => {
                    const isFlyerClassShouldBeRemoved = action.payload.find((updatedClass) => updatedClass.id === flyerClass.id);
                    if(isFlyerClassShouldBeRemoved){
                        flyerClass = {...isFlyerClassShouldBeRemoved}
                    }
                    return flyerClass;
                }),
            };
        }
        case ActionType.UPDATE_FLYER_CLASS_ERROR: {
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        }
        case ActionType.UPDATE_FLYER_CLASS_COMPLETE: {
            return { ...state, error: null, loading: false, type: action.type };
        }

        default: {
            return state;
        }
    }

}
